<template>
  <b-container>
    <b-row class="text-center pt-4">
      NotFound
    </b-row>
  </b-container>
</template>

<script>
export default {
props: [],
data: () => ({}),
computed: {},
methods:{},
components: {}
}
</script>
